import { VersionedAbstractEntity } from "../VersionedAbstractEntity";
export const soundingLocationOptions = ['deck', 'engine'];
export const typeOfSoundingOptions = ['ullage', 'sounding'];
export default class SoundingSpot extends VersionedAbstractEntity {
    name;
    location;
    typeOfSounding;
    unit;
    constructor(soundingSpot = {}) {
        super();
        Object.assign(this, soundingSpot);
    }
}
//# sourceMappingURL=SoundingSpot.js.map